import React, { useEffect, useState, useRef } from "react";
import WebInput from "../../../../component/library/webInput";
import WebDropdown from "../../../../component/library/webDropdown";
import { productListApiService } from "../../../../service/admin/productApiService";
import { useNavigate, useParams } from "react-router-dom";
import WebButton from "../../../../component/library/webButton";
import "./style.css";
import { RxCross2 } from "react-icons/rx";
import { useLoader } from "../../../../base/context/LoaderProvider";
import {
  ToastTypes,
  useMessage,
} from "../../../../base/context/MessageProvider";
import { normalizeUrl, handleImgError } from "../../../../utils/imageUtils";
import VariantPriceModal from "../../productDrafts/edit/VariantPriceModal";
import { applyBulkPricing, syncVariantPricing } from "../../productDrafts/edit/variantPricing";
import PriceLogPanel from "../../productDrafts/edit/PriceLogPanel";
import { adminApiService } from "../../../../service/admin/adminApiService";

export default function EditProduct() {
  const [data, setData] = useState({});
  const loader = useLoader();
  const message = useMessage();
  const params = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState({});
  const [selectedImage, setSeletedImage] = useState(null);
  const [variantSelection, setVariantSelection] = useState({});
  const [variantPriceModalOpen, setVariantPriceModalOpen] = useState(false);
  const [activeVariant, setActiveVariant] = useState(null);
  const [activeVariantIndex, setActiveVariantIndex] = useState(null);
  const [activeSection, setActiveSection] = useState("basic-info");
  const [collapsed, setCollapsed] = useState({});
  const [loading, setLoading] = useState(false);
  
  const [bulkPercentage, setBulkPercentage] = useState("");
  const [bulkTargetPrice, setBulkTargetPrice] = useState("");
  const [bulkMarkupMode, setBulkMarkupMode] = useState("percentage"); // default selected
  const [variantBulkMenuOpen, setVariantBulkMenuOpen] = useState(false);
  const variantBulkMenuRef = useRef(null);
  const [variantUpdating, setVariantUpdating] = useState(false);
  
  // Pricing mode: "dropshipping" or "wholesale"
  const [pricingMode, setPricingMode] = useState("dropshipping");

  // Price Range breakdown (right-side drawer)
  const [priceRangeCalcOpen, setPriceRangeCalcOpen] = useState(false);
  const [priceRangeCalcMeta, setPriceRangeCalcMeta] = useState(null); // { index, ap }
  const [priceRangeCalcResult, setPriceRangeCalcResult] = useState(null); // { algorithm, breakdown }
  const [priceRangeCalcLoading, setPriceRangeCalcLoading] = useState(false);
  const [priceRangeCalcError, setPriceRangeCalcError] = useState("");
  const priceRangeCalcRef = useRef({ timers: {}, reqSeq: {} });

  // Store original variant values to reset unsaved changes on tab switch
  const originalVariantsRef = useRef([]);

  // Handle pricing mode change with reset logic for unsaved dimension changes
  const handlePricingModeChange = (newMode) => {
    if (newMode === pricingMode) return;
     //  Commented reset logic (we don't want reset anymore)

    // const trackFields = ["length", "width", "height", "weight"];

    // // helper: find original variant by key
    // const findOrigVariant = (v, i) => {
    //   const key = getVarKey(v, i);
    //   const origArr = Array.isArray(originalVariantsRef.current)
    //     ? originalVariantsRef.current
    //     : [];
    //   return (
    //     origArr.find((ov, oi) => getVarKey(ov, oi) === key) ||
    //     origArr[i] ||
    //     null
    //   );
    // };

    // // detect unsaved changes
    // let hasUnsaved = false;
    // if (Array.isArray(data?.variations) && data.variations.length) {
    //   for (let i = 0; i < data.variations.length; i++) {
    //     const v = data.variations[i];
    //     const ov = findOrigVariant(v, i);
    //     if (!ov) continue;

    //     if (trackFields.some((f) => (v?.[f] ?? null) !== (ov?.[f] ?? null))) {
    //       hasUnsaved = true;
    //       break;
    //     }
    //   }
    // }

    // // if unsaved changes exist → reset to last saved snapshot
    // if (hasUnsaved) {
    //   setData((prev) => ({
    //     ...prev,
    //     variations: (prev?.variations || []).map((v, i) => {
    //       const ov = findOrigVariant(v, i);
    //       if (!ov) return v;

    //       const next = { ...v };
    //       trackFields.forEach((f) => {
    //         next[f] = ov?.[f];
    //       });
    //       return next;
    //     }),
    //   }));
    // }

    setPricingMode(newMode);
  };

  const [priceLogs, setPriceLogs] = useState(null);      // null = loading state
  const [priceLogLoading, setPriceLogLoading] = useState(false);

  // ===== Remark Modal (Variant / Product) =====
  const [remarkModalOpen, setRemarkModalOpen] = useState(false);
  const [remarkText, setRemarkText] = useState("");
  const remarkContextRef = useRef({ type: null, index: null }); // { type: "VARIANT"|"PRODUCT", index?: number }
  
  // original snapshot for change-check
  const originalDataRef = useRef(null);

  // Track base finalPrice for each variant (latest saved finalPrice)
  // This is used for percentage calculations
  const baseFinalPriceRef = useRef({}); // { variantKey: finalPrice }
  
  // Track base wholesaleFinalPrice for each variant (latest saved wholesaleFinalPrice)
  // This is used for wholesale percentage calculations to prevent cumulative calculations
  const baseWholesalePriceRef = useRef({}); // { variantKey: wholesaleFinalPrice }


  const [sectionCompletion, setSectionCompletion] = useState({
  basicInfo: false,
  pricingInventory: false,
  dimensionsWeight: false,
  images: false,
  variations: false,
  productDetails: false,
  seoKeywords: false,
  draftInfo: false,
});

useEffect(() => {
  const checkCompletionStatus = () => {
    setSectionCompletion({
      basicInfo: !!(data.title || data.sku || data.categoryId),  
      pricingInventory: !!(data.mrp || data.vendor_price || data.sp || data.quantity),  
      dimensionsWeight: !!(data.length || data.width || data.height || data.weight),  
      images: data.imgUrl && data.imgUrl.length > 0,  
      variations: data.variations && data.variations.length > 0,  
      productDetails: !!(data.feed_product_type || data.style_name || data.size_map), 
      seoKeywords: !!(data.generic_keywords || data.search_terms && data.search_terms.length > 0),  
      draftInfo: !!(data.offerId || data.source), 
    });
  };

  checkCompletionStatus();
}, [data]); 

  
  const formRef = useRef(null);
  const contentScrollRef = useRef(null)

  useEffect(() => {
    fetchDetails();
  }, []);

const getVarKey = (v, i) => v?.sku || v?.skuId || v?.specId || `${v?.color || ""}-${v?.size || ""}` || String(i);

// Calculate minimum finalPrice from all variants
// Calculate minimum finalPrice from all variants (based on current pricing mode)
const getMinVariantPrice = (variations) => {
  if (!variations || !Array.isArray(variations) || variations.length === 0) return null;
  
  const prices = variations
    .map(v => {
      if (pricingMode === "wholesale") {
        return v.wholesaleFinalPrice != null ? Number(v.wholesaleFinalPrice) : null;
      } else {
        return v.finalPrice != null ? Number(v.finalPrice) : null;
      }
    })
    .filter(p => p != null && p > 0);
  
  if (prices.length === 0) return null;
  return Math.min(...prices);
};

// Update SP and MRP based on minimum variant price
const updateSpFromMinVariantPrice = () => {
  const minPrice = getMinVariantPrice(data.variations);
  if (minPrice != null && minPrice > 0) {
    const newSp = minPrice;
    const newMrp = Number((newSp * 2.5).toFixed(2));
    
    // Only update if SP is different
    if (data.sp !== newSp) {
      setData((prev) => ({
        ...prev,
        sp: newSp,
        mrp: newMrp
      }));
      return true; // SP was updated
    }
  }
  return false; // SP was not updated
};

const applyBulkPercentageToAllVariants = () => {
  // Create a map of latest price (from baseFinalPriceRef or current saved value) for each variant
  const latestPriceMap = {};
  (data.variations || []).forEach((variant, idx) => {
    const key = getVarKey(variant, idx);
    if (pricingMode === "wholesale") {
      // For wholesale, use wholesaleFinalPrice
      // Priority: originalDataRef (saved wholesaleFinalPrice) > current wholesaleFinalPrice
      let baseWfp = null;
      if (originalDataRef.current && Array.isArray(originalDataRef.current.variations)) {
        const matchedOrig = originalDataRef.current.variations.find(ov => 
          (ov.skuId && variant.skuId && String(ov.skuId) === String(variant.skuId)) ||
          (ov.specId && variant.specId && String(ov.specId) === String(variant.specId))
        );
        if (matchedOrig && matchedOrig.wholesaleFinalPrice != null) {
          baseWfp = matchedOrig.wholesaleFinalPrice;
        }
      }
      if (baseWfp == null && variant.wholesaleFinalPrice != null) {
        baseWfp = variant.wholesaleFinalPrice;
      }
      if (baseWfp != null) {
        latestPriceMap[key] = baseWfp;
      }
    } else {
      // For dropshipping, use finalPrice
      if (baseFinalPriceRef.current[key] != null) {
        latestPriceMap[key] = baseFinalPriceRef.current[key];
      } else if (variant.finalPrice != null) {
        latestPriceMap[key] = variant.finalPrice;
      }
    }
  });
  
  // Get original variations from originalDataRef for fallback
  const originalVariations = originalDataRef.current?.variations || null;
  
  const updated = applyBulkPricing({
    variations: data.variations || [],
    selectionMap: variantSelection,
    getKey: getVarKey,
    mode: "percentage",
    value: bulkPercentage,
    originalVariations: originalVariations,
    firstTimePriceMap: latestPriceMap, // Pass latest price map (using firstTimePriceMap parameter name for compatibility)
    pricingMode: pricingMode,
  });
  // Recalculate SP from minimum variant finalPrice (INR)
  const minPriceP = getMinVariantPrice(updated);
  const spUpdateP = {};
  if (minPriceP != null && minPriceP > 0) {
    spUpdateP.sp = minPriceP;
    spUpdateP.mrp = Number((minPriceP * 2.5).toFixed(2));
  }
  setData((prev) => ({ ...prev, variations: updated, ...spUpdateP }));
};


const fetchPriceLogs = (pid, offId) => {
  if (!pid) return;
  setPriceLogLoading(true);

  const qs = new URLSearchParams();
  qs.set("page", "1");
  qs.set("limit", "100");
  // qs.set("status", "5");
  if (offId) qs.set("offerId", offId);

  productListApiService
    .getProductPriceLogs(pid, `?${qs.toString()}`)
    .then((res) => {
      if (res?.status?.code === 200) {
        setPriceLogs(res?.data?.logs || []);
      } else {
        setPriceLogs([]);
      }
      setPriceLogLoading(false);
    })
    .catch(() => {
      setPriceLogs([]);
      setPriceLogLoading(false);
    });
};

const applyBulkTargetPriceToAllVariants = () => {
  // Create a map of latest price (from baseFinalPriceRef or current saved value) for each variant
  const latestPriceMap = {};
  (data.variations || []).forEach((variant, idx) => {
    const key = getVarKey(variant, idx);
    if (pricingMode === "wholesale") {
      // For wholesale, use wholesaleFinalPrice
      // Priority: originalDataRef (saved wholesaleFinalPrice) > current wholesaleFinalPrice
      let baseWfp = null;
      if (originalDataRef.current && Array.isArray(originalDataRef.current.variations)) {
        const matchedOrig = originalDataRef.current.variations.find(ov => 
          (ov.skuId && variant.skuId && String(ov.skuId) === String(variant.skuId)) ||
          (ov.specId && variant.specId && String(ov.specId) === String(variant.specId))
        );
        if (matchedOrig && matchedOrig.wholesaleFinalPrice != null) {
          baseWfp = matchedOrig.wholesaleFinalPrice;
        }
      }
      if (baseWfp == null && variant.wholesaleFinalPrice != null) {
        baseWfp = variant.wholesaleFinalPrice;
      }
      if (baseWfp != null) {
        latestPriceMap[key] = baseWfp;
      }
    } else {
      // For dropshipping, use finalPrice
      if (baseFinalPriceRef.current[key] != null) {
        latestPriceMap[key] = baseFinalPriceRef.current[key];
      } else if (variant.finalPrice != null) {
        latestPriceMap[key] = variant.finalPrice;
      }
    }
  });
  
  // Get original variations from originalDataRef for fallback
  const originalVariations = originalDataRef.current?.variations || null;
  
  const updated = applyBulkPricing({
    variations: data.variations || [],
    selectionMap: variantSelection,
    getKey: getVarKey,
    mode: "targetPrice",
    value: bulkTargetPrice,
    originalVariations: originalVariations,
    firstTimePriceMap: latestPriceMap, // Pass latest price map (using firstTimePriceMap parameter name for compatibility)
    pricingMode: pricingMode,
  });
  // Recalculate SP from minimum variant finalPrice (INR)
  const minPriceT = getMinVariantPrice(updated);
  const spUpdateT = {};
  if (minPriceT != null && minPriceT > 0) {
    spUpdateT.sp = minPriceT;
    spUpdateT.mrp = Number((minPriceT * 2.5).toFixed(2));
  }
  setData((prev) => ({ ...prev, variations: updated, ...spUpdateT }));
};

// Calculate selected variants count
const totalVariants = Array.isArray(data?.variations) ? data.variations.length : 0;
const selectedCount = Array.isArray(data?.variations)
  ? data.variations.reduce((acc, v, i) => {
      const key = getVarKey(v, i);
      return acc + (key && variantSelection?.[key] ? 1 : 0);
    }, 0)
  : 0;

const isBulkApplyDisabled = 
  bulkMarkupMode === "percentage"
    ? !bulkPercentage || bulkPercentage === ""
    : !bulkTargetPrice || bulkTargetPrice === "";

const allVariantsChecked = totalVariants > 0 && selectedCount === totalVariants;
const allVariantsUnchecked = totalVariants > 0 && selectedCount === 0;

// Close bulk menu when clicking outside
useEffect(() => {
  const onDocClick = (e) => {
    if (!variantBulkMenuRef.current) return;
    if (!variantBulkMenuRef.current.contains(e.target)) {
      setVariantBulkMenuOpen(false);
    }
  };
  document.addEventListener("mousedown", onDocClick);
  return () => document.removeEventListener("mousedown", onDocClick);
}, []);

  const doEditProduct = (remark = "", updatedSp = null, updatedMrp = null) => {
    setLoading(true);
    loader.showLoading(true);

    // Get selected variations only
    const selectedVariations = Array.isArray(data.variations)
      ? data.variations.filter(v => {
          const key = v?.sku || v?.skuId || v?.specId || `${v?.color || ''}-${v?.size || ''}`;
          return key ? !!variantSelection[key] : false;
        })
      : [];

    const payload = {
      categoryId: data.categoryId,
      sku: data?.sku,
      title: data?.title,
      nodeId: data?.nodeId,
      description: data?.description,
      quantity: data?.quantity,
      length: data?.length,
      width: data?.width,
      height: data?.height,
      weight: data?.weight,
      pack_unit: data?.pack_unit,
      vendor_price: data?.vendor_price,
      mrp: updatedMrp != null ? updatedMrp : data?.mrp,
      sp: updatedSp != null ? updatedSp : data?.sp,
      warranty: data?.warranty,
      hsn: data?.hsn,
      brand: data?.brand,
      location: data?.location,
      priceRanges: data?.priceRanges || [],
      productSaleInfo: data?.productSaleInfo,
      variations: selectedVariations.map((variation) => ({
        ...variation,
        skuId: variation.skuId,
        amountOnSale: variation.amountOnSale,
        cp: variation.cp || variation.consignPrice,
        weight: variation.weight,
        length: variation.length,
        height: variation.height,
        width: variation.width,
        actualPrice: variation.actualPrice,
        finalPrice: variation.finalPrice,
        finalPriceMRP: variation.finalPriceMRP,
        price: variation.price,
        fenxiaoPriceInfo: variation.fenxiaoPriceInfo,
        shippingDetail: variation.shippingDetail,

        percentage: variation.percentage,
        targetPrice: variation.targetPrice,
        // Wholesale pricing fields
        wholesaleFinalPrice: variation.wholesaleFinalPrice,
        wholesalePercentage: variation.wholesalePercentage,
        wholesaleTargetPrice: variation.wholesaleTargetPrice,
      })),
      remark,  // product-level remark
      pricingMode, // Pass current pricing mode (dropshipping or wholesale) for price log
    };
    console.log("payload", payload);
    productListApiService
      .editProducts(JSON.stringify(payload), params.id)
      .then((res) => {
        if (res.status.code === 200) {
          setLoading(false);
          loader.showLoading(false);
          message.showToast("Product edited successfully", ToastTypes.SUCCESS);
          fetchDetails();
          fetchPriceLogs(params.id, data?.offerId);
        } else {
          setLoading(false);
          loader.showLoading(false);
          message.showToast(res.error.message, ToastTypes.ERROR);
        }
      })
      .catch((err) => {
        setLoading(false);
        message.showToast(err?.message || "Server error. Try again later", ToastTypes.ERROR);
        loader.showLoading(false);
      });
  };

const editProduct = () => {
  // only ask remark if SP changed OR any selected variant changed
  const needRemark = hasSpChange() || hasAnyVariantChange();
  if (needRemark) {
    openRemarkModal("PRODUCT");
    return;
  }
  doEditProduct(""); // no remark needed
};

const submitRemark = () => {
  if (loading || variantUpdating) return; // prevent double submit while API running
  const remark = String(remarkText || "").trim();
  if (!remark) {
    message.showToast("Remark is mandatory", ToastTypes.ERROR);
    return;
  }
  const ctx = remarkContextRef.current;
  closeRemarkModal();
  if (ctx.type === "VARIANT" && typeof ctx.index === "number") {
    submitVariantUpdateWithRemark(ctx.index, remark);
    return;
  }
  if (ctx.type === "PRODUCT") {
    doEditProduct(remark);
    return;
  }
};

const openRemarkModal = (type, index = null) => {
  remarkContextRef.current = { type, index };
  setRemarkText("");
  setRemarkModalOpen(true);
};

const closeRemarkModal = () => {
  setRemarkModalOpen(false);
  setRemarkText("");
  remarkContextRef.current = { type: null, index: null };
};

const getTrackFields = () => [
  "finalPrice",
  "finalPriceMRP",
  "actualPrice",
  "percentage",
  "targetPrice",
  "wholesaleFinalPrice",
  "wholesalePercentage",
  "wholesaleTargetPrice",
  "amountOnSale",
  "length",
  "width",
  "height",
  "weight",
];

const findOrigVariant = (variant) => {
  const orig = originalDataRef.current;
  if (!orig || !Array.isArray(orig.variations)) return null;

  return (
    orig.variations.find((v) => {
      if (variant?.skuId && String(v.skuId) === String(variant.skuId)) return true;
      if (variant?.specId && v?.specId && String(v.specId) === String(variant.specId)) return true;
      return false;
    }) || null
  );
};

const hasAnyVariantChange = () => {
  const orig = originalDataRef.current;
  if (!orig) return false;

  const track = getTrackFields();
  const selectedNow = Array.isArray(data.variations)
    ? data.variations.filter((v) => {
        const key = v?.sku || v?.skuId || v?.specId || `${v?.color || ""}-${v?.size || ""}`;
        return key ? !!variantSelection[key] : false;
      })
    : [];

  for (const v of selectedNow) {
    const ov = findOrigVariant(v);
    if (!ov) continue;
    if (track.some((f) => (v?.[f] ?? null) !== (ov?.[f] ?? null))) return true;
  }
  return false;
};

const hasSpChange = () => {
  const orig = originalDataRef.current;
  if (!orig) return false;
  return (data?.sp ?? null) !== (orig?.sp ?? null);
};


  const fetchDetails = () => {
    loader.showLoading(true);
    productListApiService
      .getProductById(params.id)
      .then((res) => {
        if (res.status.code === 200) {
          loader.showLoading(false);
        } else {
          message.showToast(res.error.message, ToastTypes.ERROR);
        }
        const productData = res.data;
        
        // Update SP and MRP based on minimum variant price
        const minPrice = getMinVariantPrice(productData.variations);
        if (minPrice != null && minPrice > 0) {
          productData.sp = minPrice;
          productData.mrp = Number((minPrice * 2.5).toFixed(2));
        }
        
        setData(productData);
        // Store original variants snapshot (used for reset on DS/WS tab switch)
        originalVariantsRef.current = Array.isArray(productData?.variations)
          ? productData.variations.map((v) => ({ ...v }))
          : [];

        originalDataRef.current = productData;
        fetchPriceLogs(params.id, productData?.offerId);
        
        // Initialize variant selection - all variants selected by default
        // Also initialize baseFinalPriceRef and baseWholesalePriceRef with current saved price values
        if (productData.variations && Array.isArray(productData.variations)) {
          const selection = {};
          const baseFinalPriceMap = {};
          const baseWholesalePriceMap = {};
          productData.variations.forEach((v, idx) => {
            const key = v?.sku || v?.skuId || v?.specId || `${v?.color || ''}-${v?.size || ''}` || String(idx);
            if (key) {
              selection[key] = true; // All selected by default
              // Store current finalPrice as base (latest saved value) for dropshipping
              if (v.finalPrice != null) {
                baseFinalPriceMap[key] = v.finalPrice;
              }
              // Store current wholesaleFinalPrice as base (latest saved value) for wholesale
              if (v.wholesaleFinalPrice != null) {
                baseWholesalePriceMap[key] = v.wholesaleFinalPrice;
              }
            }
          });
          setVariantSelection(selection);
          baseFinalPriceRef.current = baseFinalPriceMap;
          baseWholesalePriceRef.current = baseWholesalePriceMap;
        }
      })
      .catch((err) => {
        message.showToast(err?.message || "Server error. Try again later", ToastTypes.ERROR);
        loader.showLoading(false);
      });
  };


  const handlePriceRangesChange = (field, value, index) => {
    const updated = [...(data.priceRanges || [])];
  
    if (!updated[index]) {
      updated[index] = {
        startQuantity: 0,
        price: "",
        finalPrice: "",
        id: `priceRange_${Date.now()}_${index}`,
      };
    }
  
    updated[index] = { ...updated[index], [field]: value };
  
    setData((prev) => ({ ...prev, priceRanges: updated }));
  
    // Auto calculate on RMB price change
    if (field === "price") {
      const timers = priceRangeCalcRef.current.timers;
      const reqSeq = priceRangeCalcRef.current.reqSeq;
  
      reqSeq[index] = (reqSeq[index] || 0) + 1;
      const currentSeq = reqSeq[index];
  
      if (timers[index]) clearTimeout(timers[index]);
  
      timers[index] = setTimeout(async () => {
        const ap = Number(value || 0);
        if (!ap || ap <= 0) {
          setPriceRangeCalcOpen(false);
          setPriceRangeCalcResult(null);
          setPriceRangeCalcError("");
          return;
        }
  
        // open drawer
        setPriceRangeCalcOpen(true);
        setPriceRangeCalcMeta({ index, ap });
        setPriceRangeCalcLoading(true);
        setPriceRangeCalcError("");
  
        try {
          const hasDims =
            Number(data.length || 0) > 0 &&
            Number(data.width || 0) > 0 &&
            Number(data.height || 0) > 0;
  
          const deadWeightKg =
            Number(data.weight || 0) > 0 ? Number(data.weight || 0) / 1000 : 0.5;
  
          const volumetricWeightKg = hasDims
            ? (Number(data.length) * Number(data.width) * Number(data.height)) / 5000
            : 0.5;
  
          const payload = {
            ap,
            ls: Number(data.local_shipping || 0),
            hsn: false,
            dw: deadWeightKg,
            vw: volumetricWeightKg,
            hsnTaxPercent: 12,
            categoryId: data.categoryId || "",
            sku: data?.sku || "",
          };
  
          const response = await adminApiService.post("/pricing-algorithms/calculate", payload);
  
          // ignore stale response
          if (priceRangeCalcRef.current.reqSeq[index] !== currentSeq) return;
  
          const breakdown = response?.data?.breakdown || response?.breakdown;
          const algorithm = response?.data?.algorithm || response?.algorithm || "";
  
          if (!breakdown) throw new Error("Invalid response: breakdown not found");
  
          const fbp = Number(breakdown.FBP || 0);
          const finalPrice = fbp > 0 ? String(Math.round(fbp)) : "";
  
          // update finalPrice
          setData((prev) => {
            const next = [...(prev.priceRanges || [])];
            if (!next[index]) return prev;
  
            next[index] = { ...next[index], finalPrice };
            return { ...prev, priceRanges: next };
          });
  
          setPriceRangeCalcResult({
            algorithm,
            breakdown: {
              ...breakdown,
              deadWeightKg: Math.round(deadWeightKg * 1000) / 1000,
              volumetricWeightKg: Math.round(volumetricWeightKg * 1000) / 1000,
            },
          });
        } catch (e) {
          const msg =
            e?.response?.data?.message ||
            e?.response?.data?.error ||
            e?.message ||
            "Failed to calculate price";
  
          setPriceRangeCalcError(msg);
          setPriceRangeCalcResult(null);
        } finally {
          setPriceRangeCalcLoading(false);
        }
      }, 350);
    }
  };

  const handleOnchange = (e) => {
    const { name, value } = e.target;
    const next = { ...data, [name]: value };
    
    // ONLY when SP changes → auto update MRP
    if (name === "sp") {
      const spNum = Number(value || 0);
      next.mrp = Number((spNum * 2.5).toFixed(2));
    }
    
    setData(next);
    setError({ ...error, [name]: "" });
  };

  const handleImage = (e) => {
    setSeletedImage(e.target.files[0]);
  };

  const handleImageUpload = (id) => {
    loader.showLoading(true);
    const payload = new FormData();
    payload.append("images", selectedImage);
    console.log("payload", payload);
    productListApiService
      .uploadImage(payload, id)
      .then((res) => {
        if (res.status.code === 200) {
          loader.showLoading(false);
        } else {
          loader.showLoading(false);
          console.log("123");
        }
      })
      .catch((err) => {
        loader.showLoading(false);
        console.log(err);
      });
  };

  const handleRemoveImage = (index) => {
    const updatedImages = data.imgUrl.filter((_, i) => i !== index);
    setData({ ...data, imgUrl: updatedImages });
  };

  useEffect(() => {
    console.log("selectedImage", selectedImage);
  }, [selectedImage]);

  // Image handling functions
  const normalizeUrl = (url) => {
    if (!url) return "";
    try { 
      return String(url).replace(/^http:\/\//, "https://"); 
    } catch { 
      return url; 
    }
  };

  const handleImgError = (e) => { 
    // e.currentTarget.src = Logo; 
  };

const handleVariationChange = (index, field, value) => {
  const updatedVariations = [...data.variations];
  const currentVar = updatedVariations[index];
  const variantKey = getVarKey(currentVar, index);
  
  // Store old percentage value BEFORE updating (to detect unsaved changes)
  const oldPercentage = currentVar.percentage;

  if (field.includes(".")) {
    const fields = field.split(".");
    if (!updatedVariations[index][fields[0]]) updatedVariations[index][fields[0]] = {};
    updatedVariations[index][fields[0]][fields[1]] =
      value === "" ? "" : (isNaN(value) ? value : Number(value));
  } else {
    updatedVariations[index][field] =
      value === "" ? "" : (isNaN(value) ? value : Number(value));
  }

  // Get base finalPrice for percentage calculations
  // Priority: latest saved finalPrice (baseFinalPriceRef) > current finalPrice from DB (originalDataRef)
  let baseFinalPrice = null;
  let originalFinalPrice = null; // Fallback for unsaved changes
  
  // Get latest saved finalPrice from baseFinalPriceRef (this is updated after save)
  if (baseFinalPriceRef.current[variantKey] != null) {
    baseFinalPrice = baseFinalPriceRef.current[variantKey];
  }
  
  // If baseFinalPrice not found, get from originalDataRef (current saved value from DB)
  if (baseFinalPrice == null && originalDataRef.current && Array.isArray(originalDataRef.current.variations)) {
    const origVar = originalDataRef.current.variations[index];
    // Try to match by skuId or specId to get the correct original variant
    const matchedOrig = originalDataRef.current.variations.find(ov => 
      (ov.skuId && currentVar.skuId && String(ov.skuId) === String(currentVar.skuId)) ||
      (ov.specId && currentVar.specId && String(ov.specId) === String(currentVar.specId))
    ) || origVar;
    if (matchedOrig && matchedOrig.finalPrice != null) {
      baseFinalPrice = matchedOrig.finalPrice;
      originalFinalPrice = matchedOrig.finalPrice; // Also set as fallback
    }
  }
  
  // If still not found, use current finalPrice
  if (baseFinalPrice == null && currentVar.finalPrice != null) {
    baseFinalPrice = currentVar.finalPrice;
  }

  // For percentage changes: if there are unsaved changes (percentage was already set), 
  // use original base (before first unsaved change) instead of latest saved
  if (field === "percentage") {
    // Check if percentage was already set (indicating unsaved changes)
    const hadPercentage = oldPercentage != null && oldPercentage !== "";
    if (hadPercentage && originalFinalPrice != null) {
      // Use original base for unsaved changes
      baseFinalPrice = originalFinalPrice;
    }
  }

  // Handle pricing mode-specific fields
  if (pricingMode === "wholesale") {
    if (field === "wholesalePercentage" || field === "wholesaleTargetPrice" || field === "wholesaleFinalPrice") {
      // Get base wholesaleFinalPrice for wholesale mode
      // CRITICAL: Always use baseWholesalePriceRef (immutable original saved price) to prevent cumulative calculations
      // NEVER use currentVar.wholesaleFinalPrice as it may be already modified
      let baseWholesalePrice = null;
      
      // Priority 1: Get from baseWholesalePriceRef (latest saved wholesaleFinalPrice, immutable)
      if (variantKey && baseWholesalePriceRef.current[variantKey] != null) {
        baseWholesalePrice = baseWholesalePriceRef.current[variantKey];
      }
      // Priority 2: Fallback to originalDataRef (saved wholesaleFinalPrice from DB)
      else if (originalDataRef.current && Array.isArray(originalDataRef.current.variations)) {
        const matchedOrig = originalDataRef.current.variations.find(ov => 
          (ov.skuId && currentVar.skuId && String(ov.skuId) === String(currentVar.skuId)) ||
          (ov.specId && currentVar.specId && String(ov.specId) === String(currentVar.specId))
        );
        if (matchedOrig && matchedOrig.wholesaleFinalPrice != null) {
          baseWholesalePrice = matchedOrig.wholesaleFinalPrice;
        }
      }
      // DO NOT fallback to currentVar.wholesaleFinalPrice - it may be already modified!
      // This prevents cumulative percentage calculations
      
      const synced = syncVariantPricing(
        { ...currentVar, [field]: value === "" ? "" : (isNaN(value) ? value : Number(value)) },
        field === "wholesalePercentage" ? "wholesalePercentage" : field === "wholesaleTargetPrice" ? "wholesaleTargetPrice" : "wholesaleFinalPrice",
        baseWholesalePrice,
        null,
        pricingMode
      );
      Object.assign(updatedVariations[index], synced);
      setData((prev) => ({ ...prev, variations: updatedVariations }));
      return;
    }
  } else {
    // common sync - pass baseFinalPrice as the main parameter, originalFinalPrice as fallback, and pricingMode
    if (field === "percentage" || field === "targetPrice" || field === "finalPrice") {
      updatedVariations[index] = syncVariantPricing(updatedVariations[index], field, baseFinalPrice, originalFinalPrice, pricingMode);
    }
  }

  // Update SP and MRP based on minimum variant price if price changed
  const updatedData = { ...data, variations: updatedVariations };
  if (field === "finalPrice" || field === "percentage" || field === "targetPrice" || 
      field === "wholesaleFinalPrice" || field === "wholesalePercentage" || field === "wholesaleTargetPrice") {
    const minPrice = getMinVariantPrice(updatedVariations);
    if (minPrice != null && minPrice > 0) {
      updatedData.sp = minPrice;
      updatedData.mrp = Number((minPrice * 2.5).toFixed(2));
    }
  }

  setData(updatedData);
};

  const toggleVariantSelection = (variant) => {
    const key = variant?.sku || variant?.skuId || variant?.specId || `${variant?.color || ''}-${variant?.size || ''}`;
    if (!key) return;
    setVariantSelection(prev => ({ ...prev, [key]: !prev[key] }));
  };

  const setAllVariants = (checked) => {
    setVariantSelection(prev => {
      const newSelection = {};
      (data.variations || []).forEach(v => {
        const key = v?.sku || v?.skuId || v?.specId || `${v?.color || ''}-${v?.size || ''}`;
        if (key) {
          newSelection[key] = checked;
        }
      });
      return newSelection;
    });
  };

  const openVariantPriceModal = (variation, index) => {
    setActiveVariant(variation);
    setActiveVariantIndex(index);
    setVariantPriceModalOpen(true);
  };

  const closeVariantPriceModal = () => {
    setVariantPriceModalOpen(false);
    setActiveVariant(null);
    setActiveVariantIndex(null);
  };

const applyVariantDimensions = (dimensions) => {
  if (activeVariantIndex == null) return;

  // Use functional update to get the latest state (which includes price updates)
  setData((prev) => {
    const updatedVariations = [...prev.variations];
    const currentVar = updatedVariations[activeVariantIndex];
    
    // Update all dimensions at once, preserving any existing updates
    updatedVariations[activeVariantIndex] = {
      ...currentVar,
      ...(dimensions.weight != null && { weight: dimensions.weight }),
      ...(dimensions.length != null && { length: dimensions.length }),
      ...(dimensions.height != null && { height: dimensions.height }),
      ...(dimensions.width != null && { width: dimensions.width }),
    };

    return { ...prev, variations: updatedVariations };
  });
};

const applyVariantPrice = (finalPrice, wholesaleFinalPrice = null) => {
  if (activeVariantIndex == null) return;

  // Use functional update to get the latest state (which includes dimension updates)
  setData((prev) => {
    const updatedVariations = [...prev.variations];
    
    const currentVar = updatedVariations[activeVariantIndex];
    const variantKey = getVarKey(currentVar, activeVariantIndex);
    
    // Update both DS and WS prices if provided
    if (finalPrice != null) {
      // For dropshipping: update finalPrice
      // Get base finalPrice (latest saved) for percentage calculation
      let baseFinalPrice = null;
      
      // Get latest saved finalPrice from baseFinalPriceRef
      if (baseFinalPriceRef.current[variantKey] != null) {
        baseFinalPrice = baseFinalPriceRef.current[variantKey];
      }
      
      // Fallback to originalDataRef if baseFinalPriceRef doesn't have it
      if (baseFinalPrice == null && originalDataRef.current && Array.isArray(originalDataRef.current.variations)) {
        const origVar = originalDataRef.current.variations[activeVariantIndex];
        // Try to match by skuId or specId to get the correct original variant
        const matchedOrig = originalDataRef.current.variations.find(ov => 
          (ov.skuId && currentVar.skuId && String(ov.skuId) === String(currentVar.skuId)) ||
          (ov.specId && currentVar.specId && String(ov.specId) === String(currentVar.specId))
        ) || origVar;
        if (matchedOrig && matchedOrig.finalPrice != null) {
          baseFinalPrice = matchedOrig.finalPrice;
        }
      }
      
      // If still not found, use current finalPrice
      if (baseFinalPrice == null && currentVar.finalPrice != null) {
        baseFinalPrice = currentVar.finalPrice;
      }
      
      // If baseFinalPrice is still null, use the new finalPrice as base (first time setting)
      if (baseFinalPrice == null) {
        baseFinalPrice = finalPrice;
      }
      
      // Set targetPrice to the calculated price, which will automatically set finalPrice = targetPrice
      const v = { ...updatedVariations[activeVariantIndex], targetPrice: finalPrice };

      const syncedVariant = syncVariantPricing(v, "targetPrice", baseFinalPrice, null, "dropshipping");
      updatedVariations[activeVariantIndex] = syncedVariant;
      
      // Update baseFinalPriceRef for next time
      baseFinalPriceRef.current = {
        ...baseFinalPriceRef.current,
        [variantKey]: finalPrice,
      };
    }
    
    if (wholesaleFinalPrice != null) {
      // For wholesale: update wholesaleFinalPrice
      // Get base wholesaleFinalPrice (latest saved) for percentage calculation
      let baseWholesalePrice = null;
      
      // Get latest saved wholesaleFinalPrice from baseWholesalePriceRef
      if (baseWholesalePriceRef.current[variantKey] != null) {
        baseWholesalePrice = baseWholesalePriceRef.current[variantKey];
      }
      
      // Fallback to originalDataRef if baseWholesalePriceRef doesn't have it
      if (baseWholesalePrice == null && originalDataRef.current && Array.isArray(originalDataRef.current.variations)) {
        const origVar = originalDataRef.current.variations[activeVariantIndex];
        // Try to match by skuId or specId to get the correct original variant
        const matchedOrig = originalDataRef.current.variations.find(ov => 
          (ov.skuId && currentVar.skuId && String(ov.skuId) === String(currentVar.skuId)) ||
          (ov.specId && currentVar.specId && String(ov.specId) === String(currentVar.specId))
        ) || origVar;
        if (matchedOrig && matchedOrig.wholesaleFinalPrice != null) {
          baseWholesalePrice = matchedOrig.wholesaleFinalPrice;
        }
      }
      
      // If still not found, use current wholesaleFinalPrice
      if (baseWholesalePrice == null && currentVar.wholesaleFinalPrice != null) {
        baseWholesalePrice = currentVar.wholesaleFinalPrice;
      }
      
      // Set wholesaleTargetPrice to the calculated price, which will automatically set wholesaleFinalPrice = wholesaleTargetPrice
      const v = { ...updatedVariations[activeVariantIndex], wholesaleTargetPrice: wholesaleFinalPrice };

      updatedVariations[activeVariantIndex] = syncVariantPricing(
        v, 
        "wholesaleTargetPrice", 
        baseWholesalePrice, // baseFinalPrice parameter - pass baseWholesalePrice for wholesale
        null, // originalFinalPrice fallback
        "wholesale" // pricingMode
      );
      
      // Update baseWholesalePriceRef for next time
      baseWholesalePriceRef.current = {
        ...baseWholesalePriceRef.current,
        [variantKey]: wholesaleFinalPrice,
      };
    }
    
    // Recalculate SP from minimum variant finalPrice (INR)
    const updatedData = { ...prev, variations: updatedVariations };
    const minPrice = getMinVariantPrice(updatedVariations);
    if (minPrice != null && minPrice > 0) {
      updatedData.sp = minPrice;
      updatedData.mrp = Number((minPrice * 2.5).toFixed(2));
    }

    return updatedData;
  });
  // message.showToast("Variant final price updated from calculator", ToastTypes.SUCCESS);
};

/** Apply calculated prices and dimensions to multiple variants at once */
const applyMultipleVariants = (results) => {
  if (!results || !results.length) return;

  setData((prev) => {
    const updatedVariations = [...prev.variations];

    results.forEach(({ index, finalPrice, wholesaleFinalPrice, dimensions: dims }) => {
      if (index < 0 || index >= updatedVariations.length) return;
      let v = { ...updatedVariations[index] };
      const variantKey = getVarKey(v, index);

      // Apply dimensions
      if (dims) {
        if (dims.weight != null) v.weight = dims.weight;
        if (dims.length != null) v.length = dims.length;
        if (dims.height != null) v.height = dims.height;
        if (dims.width != null) v.width = dims.width;
      }

      // Apply DS price
      if (finalPrice != null) {
        let baseFinalPrice = baseFinalPriceRef.current[variantKey] ?? null;
        let prevPercentage = v.percentage;
        if (baseFinalPrice == null && originalDataRef.current?.variations) {
          const origVar = originalDataRef.current.variations.find(ov =>
            (ov.skuId && v.skuId && String(ov.skuId) === String(v.skuId)) ||
            (ov.specId && v.specId && String(ov.specId) === String(v.specId))
          );
          if (origVar?.finalPrice != null) baseFinalPrice = origVar.finalPrice;
          if (prevPercentage == null && origVar?.percentage != null) prevPercentage = origVar.percentage;
        }
        if (baseFinalPrice == null) baseFinalPrice = v.finalPrice ?? finalPrice;

        v = { ...v, targetPrice: finalPrice };
        v = syncVariantPricing(v, "targetPrice", baseFinalPrice, null, "dropshipping");
        if (finalPrice === baseFinalPrice && prevPercentage != null) {
          v.percentage = prevPercentage;
        }
        baseFinalPriceRef.current = { ...baseFinalPriceRef.current, [variantKey]: finalPrice };
      }

      // Apply WS price
      if (wholesaleFinalPrice != null) {
        let baseWholesalePrice = baseWholesalePriceRef.current[variantKey] ?? null;
        let prevWholesalePercentage = v.wholesalePercentage;
        if (baseWholesalePrice == null && originalDataRef.current?.variations) {
          const origVar = originalDataRef.current.variations.find(ov =>
            (ov.skuId && v.skuId && String(ov.skuId) === String(v.skuId)) ||
            (ov.specId && v.specId && String(ov.specId) === String(v.specId))
          );
          if (origVar?.wholesaleFinalPrice != null) baseWholesalePrice = origVar.wholesaleFinalPrice;
          if (prevWholesalePercentage == null && origVar?.wholesalePercentage != null) prevWholesalePercentage = origVar.wholesalePercentage;
        }
        if (baseWholesalePrice == null) baseWholesalePrice = v.wholesaleFinalPrice ?? wholesaleFinalPrice;

        v = { ...v, wholesaleTargetPrice: wholesaleFinalPrice };
        v = syncVariantPricing(v, "wholesaleTargetPrice", baseWholesalePrice, null, "wholesale");
        if (wholesaleFinalPrice === baseWholesalePrice && prevWholesalePercentage != null) {
          v.wholesalePercentage = prevWholesalePercentage;
        }
        baseWholesalePriceRef.current = { ...baseWholesalePriceRef.current, [variantKey]: wholesaleFinalPrice };
      }

      updatedVariations[index] = v;
    });

    // Recalculate SP from minimum variant finalPrice (INR)
    const updatedData = { ...prev, variations: updatedVariations };
    const minPrice = getMinVariantPrice(updatedVariations);
    if (minPrice != null && minPrice > 0) {
      updatedData.sp = minPrice;
      updatedData.mrp = Number((minPrice * 2.5).toFixed(2));
    }

    return updatedData;
  });
};

const handleUpdateVariant = (index) => {
  //  Always open modal on variant update click
  openRemarkModal("VARIANT", index);
};

const submitVariantUpdateWithRemark = (index, remark) => {
  if (variantUpdating || loading) return; //revent double call
  setVariantUpdating(true);
  loader.showLoading(true);
  const variant = data.variations[index];

  // Check if SP needs to be updated (compare original SP from DB with minimum variant price)
  // Use original SP from originalDataRef, not current state SP (which might already be updated)
  const originalSp = originalDataRef.current?.sp ?? data.sp;
  const minPrice = getMinVariantPrice(data.variations);
  const spNeedsUpdate = minPrice != null && minPrice > 0 && originalSp !== minPrice;

  // If SP needs update, call update product instead of just variant
  if (spNeedsUpdate) {
    // Reset variant updating state first (doEditProduct will handle its own loading state)
    setVariantUpdating(false);
    loader.showLoading(false);
    
    // Calculate new SP and MRP
    const newSp = minPrice;
    const newMrp = Number((minPrice * 2.5).toFixed(2));
    
    // Update SP and MRP in data with the new values
    const updatedData = {
      ...data,
      sp: newSp,
      mrp: newMrp
    };
    setData(updatedData);
    
    // Call update product with updated SP/MRP directly (to ensure correct values are sent)
    // This will update SP and all variants, and SP change will be logged
    doEditProduct(remark, newSp, newMrp);
    return;
  }

  // Create a payload with the updated variant data
  const payload = {
    skuId: variant.skuId,
    specId: variant.specId,
    update: {
      finalPrice: variant.finalPrice,
      finalPriceMRP: variant.finalPriceMRP,
      actualPrice: variant.actualPrice,
      percentage: variant.percentage,
      targetPrice: variant.targetPrice,
      wholesaleFinalPrice: variant.wholesaleFinalPrice,
      wholesalePercentage: variant.wholesalePercentage,
      wholesaleTargetPrice: variant.wholesaleTargetPrice,
      amountOnSale: variant.amountOnSale,
      length: variant.length,
      width: variant.width,
      height: variant.height,
      weight: variant.weight,
    },
    remark, // mandatory remark send
    pricingMode, // Pass current pricing mode (dropshipping or wholesale) for price log
  };

  // Call the API to update the variant
  productListApiService
    .updateProductVariant(params.id, payload)
    .then((res) => {
      if (res.status.code === 200) {
        message.showToast("Variant updated successfully", ToastTypes.SUCCESS);
        // Update baseFinalPriceRef with the new saved price (based on current pricing mode)
        const variantKey = getVarKey(variant, index);
        if (variantKey) {
          const basePrice = pricingMode === "wholesale" 
            ? (variant.wholesaleFinalPrice != null ? variant.wholesaleFinalPrice : null)
            : (variant.finalPrice != null ? variant.finalPrice : null);
          if (basePrice != null) {
            baseFinalPriceRef.current = {
              ...baseFinalPriceRef.current,
              [variantKey]: basePrice
            };
          }
        }
        fetchDetails(); // refresh product + pricelog
      } else {
        message.showToast(res.error.message, ToastTypes.ERROR);
      }
    })
    .catch((err) => {
      message.showToast("Failed to update variant", ToastTypes.ERROR);
    })
    .finally(() => {
      setVariantUpdating(false);
      loader.showLoading(false);
    });
};

  // Navigation handlers
  const handleAnchorClick = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
      setActiveSection(id);
    }
  };

  const toggleSection = (id) => {
    setCollapsed((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  // Scroll detection for active section
  useEffect(() => {
    const scrollEl = contentScrollRef.current;
    if (!scrollEl) return;

      const sections = [
        "basic-info",
        "pricing-inventory",
        "dimensions-weight",
        "images",
        "variations",
        "product-details",
        "seo-keywords",
        "draft-info",
      ];  
      const handleScroll = () => {
      const scrollPosition = scrollEl.scrollTop + 200;

      for (let i = sections.length - 1; i >= 0; i--) {
        const section = document.getElementById(sections[i]);
        if (section && section.offsetTop <= scrollPosition) {
          setActiveSection(sections[i]);
          break;
        }
      }
    };
  
  scrollEl.addEventListener("scroll", handleScroll, { passive: true });
  handleScroll(); // init

  return () => scrollEl.removeEventListener("scroll", handleScroll);
}, []);

  const handleProductSaleInfoChange = (field, value, index) => {
    const updatedProductSaleInfo = { ...data.productSaleInfo };

    if (field.includes(".")) {
      const fields = field.split(".");
      const mainField = fields[0];
      const nestedField = fields[1];

      if (mainField === "priceRangeList") {
        const updatedPriceRangeList = [...(updatedProductSaleInfo[mainField] || [])];
        updatedPriceRangeList[index] = {
          ...updatedPriceRangeList[index],
          [nestedField]: value === "" ? "" : Number(value),
        };
        updatedProductSaleInfo[mainField] = updatedPriceRangeList;
      }
    } else {
      updatedProductSaleInfo[field] = value;
    }

    setData({ ...data, productSaleInfo: updatedProductSaleInfo });
  };
  return (
    <div className="product-list-edit-container">
      <div className="product-list-edit-sticky">
        <div className="product-list-edit-header">
          <div className="product-list-edit-title">
            <h1>Edit Product</h1>
            <p>Update product information</p>
          </div>
          <div className="product-list-edit-actions">
            <WebButton
              type="button"
              text="Cancel"
              onClick={() => navigate("/admin/products/list")}
              className="product-list-cancel-button"
            />
            <WebButton
              type="button"
              text={loading ? "Updating..." : "Update Product"}
              onClick={editProduct}
              disabled={loading}
              className="product-list-submit-button"
            />
          </div>
        </div>
        <div className="product-list-edit-subnav">
          <a href="#basic-info" className={activeSection === "basic-info" ? "product-list-active" : ""} onClick={(e) => { e.preventDefault(); handleAnchorClick("basic-info"); }}>Basic <span className={`status-badge ${sectionCompletion.basicInfo ? "ok" : "warn"}`}>{sectionCompletion.basicInfo ? "✓" : "!"} </span> </a>
          <a href="#pricing-inventory" className={activeSection === "pricing-inventory" ? "product-list-active" : ""} onClick={(e) => { e.preventDefault(); handleAnchorClick("pricing-inventory"); }}> Pricing <span className={`status-badge ${sectionCompletion.pricingInventory ? "ok" : "warn"}`}>{sectionCompletion.pricingInventory ? "✓" : "!"}</span></a>
          <a href="#images" className={activeSection === "images" ? "product-list-active" : ""} onClick={(e) => { e.preventDefault(); handleAnchorClick("images"); }}> Images
             <span className={`status-badge ${sectionCompletion.images ? "ok" : "warn"}`}>
                {sectionCompletion.images ? "✓" : "!"}
             </span>
          </a>
          <a href="#variations" className={activeSection === "variations" ? "product-list-active" : ""} onClick={(e) => { e.preventDefault(); handleAnchorClick("variations"); }}>  Variations
             <span className={`status-badge ${sectionCompletion.variations ? "ok" : "warn"}`}>
               {sectionCompletion.variations ? "✓" : "!"}
             </span>
          </a>
          <a href="#product-details" className={activeSection === "product-details" ? "product-list-active" : ""} onClick={(e) => { e.preventDefault(); handleAnchorClick("product-details"); }}> Details
             <span className={`status-badge ${sectionCompletion.productDetails ? "ok" : "warn"}`}>
               {sectionCompletion.productDetails ? "✓" : "!"}
             </span>
          </a>
          <a href="#seo-keywords" className={activeSection === "seo-keywords" ? "product-list-active" : ""}  onClick={(e) => { e.preventDefault(); handleAnchorClick("seo-keywords"); }}> SEO
            <span className={`status-badge ${sectionCompletion.seoKeywords ? "ok" : "warn"}`}>
              {sectionCompletion.seoKeywords ? "✓" : "!"}
            </span>
          </a>
           <a href="#draft-info" className={activeSection === "draft-info" ? "product-list-active" : ""}  onClick={(e) => { e.preventDefault(); handleAnchorClick("draft-info"); }}> Draft
             <span className={`status-badge ${sectionCompletion.draftInfo ? "ok" : "warn"}`}>
               {sectionCompletion.draftInfo ? "✓" : "!"}
             </span>
          </a>
        </div>
      </div>

      <form ref={formRef} className="product-list-edit-form">
        <div className="product-list-layout-with-sidenav">

          <PriceLogPanel
            offerId={data?.offerId}
            productId={params?.id}
            productData={data}
            logs={priceLogs || []}
            loading={priceLogLoading}
            onRefresh={() => fetchPriceLogs(params.id, data?.offerId)}
            onSaveActual={async (payload) => {
              loader.showLoading(true);
              try {
                const res = await productListApiService.editProducts(JSON.stringify(payload), params.id);
                if (res?.status?.code === 200) {
                  message.showToast("Actual prices set successfully", ToastTypes.SUCCESS);
                  return res;
                } else {
                  throw new Error(res?.error?.message || "Failed to set actual prices");
                }
              } catch (error) {
                message.showToast(error.message || "Failed to set actual prices", ToastTypes.ERROR);
                throw error;
              } finally {
                loader.showLoading(false);
              }
            }}
            afterSave={async () => {
              await fetchDetails();
            }}
          />

          <div ref={contentScrollRef} className="product-list-form-scroll">
            {/* Basic Information */}
            <div id="basic-info" className="product-list-form-section">
              <div className="product-list-section-header">
                <h2>Basic Information</h2>
                <button type="button" className="product-list-collapse-btn" onClick={() => toggleSection("basic-info")}>
                  {collapsed["basic-info"] ? "Expand" : "Collapse"}
                </button>
              </div>
              <div className={`product-list-section-body ${collapsed["basic-info"] ? "product-list-collapsed" : ""}`}>
                <div className="product-list-form-row">
                  <div className="product-list-form-input product-list-form-span-2">
                    <label>Category Name</label>
                    <input
                      type="text"
                      placeholder="enter category"
                      id="categoryName"
                      onChange={handleOnchange}
                      value={data?.c_name || ""}
                      name="c_name"
                      className={error.c_name ? "error" : ""}
                    />
                    {error.c_name && <span className="error-message">{error.c_name}</span>}
                  </div>
                  <div className="product-list-form-input">
                    <label>SKU</label>
                    <input
                      type="text"
                      placeholder=""
                      id="sku"
                      onChange={handleOnchange}
                      value={data?.sku || ""}
                      name="sku"
                      readOnly={true}
                    />
                    {error.sku && <span className="error-message">{error.sku}</span>}
                  </div>
                  <div className="product-list-form-input">
                    <label>BRAND</label>
                    <input
                      type="text"
                      placeholder=""
                      id="brand"
                      onChange={handleOnchange}
                      value={data?.brand || ""}
                      name="brand"
                      className={error.brand ? "error" : ""}
                    />
                    {error.brand && <span className="error-message">{error.brand}</span>}
                  </div>
                  <div className="product-list-form-input">
                    <label>LOCATION</label>
                    <input
                      type="text"
                      placeholder=""
                      id="location"
                      onChange={handleOnchange}
                      value={data?.location || ""}
                      name="location"
                      className={error.location ? "error" : ""}
                    />
                    {error.location && <span className="error-message">{error.location}</span>}
                  </div>
                </div>
                <div className="product-list-form-row">
                  <div className="product-list-form-input product-list-form-span-2">
                    <label>TITLE</label>
                    <input
                      type="text"
                      placeholder=""
                      id="title"
                      onChange={handleOnchange}
                      value={data?.title || ""}
                      name="title"
                      className={error.title ? "error" : ""}
                    />
                    {error.title && <span className="error-message">{error.title}</span>}
                  </div>
                </div>
                <div className="product-list-form-row">
                  <div className="product-list-form-input product-list-form-span-2">
                    <label>DESCRIPTION</label>
                    <textarea
                      id="description"
                      onChange={handleOnchange}
                      value={data?.description || ""}
                      name="description"
                      rows="3"
                      className={error.description ? "error" : ""}
                    />
                    {error.description && <span className="error-message">{error.description}</span>}
                  </div>
                </div>
              </div>
            </div>

            {/* Pricing & Inventory */}
            <div id="pricing-inventory" className="product-list-form-section">
              <div className="product-list-section-header">
                <h2>Pricing & Inventory</h2>
                <button type="button" className="product-list-collapse-btn" onClick={() => toggleSection("pricing-inventory")}>
                  {collapsed["pricing-inventory"] ? "Expand" : "Collapse"}
                </button>
              </div>
              <div className={`product-list-section-body ${collapsed["pricing-inventory"] ? "product-list-collapsed" : ""}`}>
                <div className="product-list-form-row">
                  <div className="product-list-form-input">
                    <label>VENDOR PRICE</label>
                    <input
                      type="text"
                      placeholder=""
                      id="vendor_price"
                      onChange={handleOnchange}
                      value={data?.vendor_price || ""}
                      name="vendor_price"
                      readOnly={true}
                    />
                    {error.vendor_price && <span className="error-message">{error.vendor_price}</span>}
                  </div>
                  <div className="product-list-form-input">
                    <label>SELLING PRICE</label>
                    <input
                      type="text"
                      placeholder=""
                      id="sp"
                      onChange={handleOnchange}
                      value={data?.sp || ""}
                      name="sp"
                      readOnly={true}
                    />
                    {error.sp && <span className="error-message">{error.sp}</span>}
                  </div>
                  <div className="product-list-form-input">
                    <label>MRP</label>
                    <input
                      type="text"
                      placeholder=""
                      id="mrp"
                      onChange={handleOnchange}
                      value={data?.mrp || ""}
                      name="mrp"
                      readOnly={true}
                    />
                    {error.mrp && <span className="error-message">{error.mrp}</span>}
                  </div>
                  <div className="product-list-form-input">
                    <label>QUANTITY</label>
                    <input
                      type="text"
                      placeholder=""
                      id="quantity"
                      onChange={handleOnchange}
                      value={data?.quantity || ""}
                      name="quantity"
                      className={error.quantity ? "error" : ""}
                    />
                    {error.quantity && <span className="error-message">{error.quantity}</span>}
                  </div>
                  <div className="product-list-form-input">
                    <label>PACKET UNIT</label>
                    <input
                      type="text"
                      placeholder=""
                      id="pack_unit"
                      onChange={handleOnchange}
                      value={data?.pack_unit || ""}
                      name="pack_unit"
                      className={error.pack_unit ? "error" : ""}
                    />
                    {error.pack_unit && <span className="error-message">{error.pack_unit}</span>}
                  </div>
                </div>
              </div>
            </div>

            {/* Dimensions & Weight */} {/* Currently hidden */}
            {/* <div id="dimensions-weight" className="product-list-form-section">
              <div className="product-list-section-header">
                <h2>Product Dimensions & Weight</h2>
                <button type="button" className="product-list-collapse-btn" onClick={() => toggleSection("dimensions-weight")}>
                  {collapsed["dimensions-weight"] ? "Expand" : "Collapse"}
                </button>
              </div>
              <div className={`product-list-section-body ${collapsed["dimensions-weight"] ? "product-list-collapsed" : ""}`}>
                <div className="product-list-form-row">
                  <WebInput
                    type="text"
                    placeholder=""
                    label="LENGTH"
                    id="length"
                    onChange={handleOnchange}
                    error={error.length}
                    value={data?.length}
                    name="length"
                  />
                  <WebInput
                    type="text"
                    placeholder=""
                    label="WIDTH"
                    id="width"
                    onChange={handleOnchange}
                    error={error.width}
                    value={data?.width}
                    name="width"
                  />
                  <WebInput
                    type="text"
                    placeholder=""
                    label="HEIGHT"
                    id="height"
                    onChange={handleOnchange}
                    error={error.height}
                    value={data?.height}
                    name="height"
                  />
                  <WebInput
                    type="text"
                    placeholder=""
                    label="WEIGHT"
                    id="weight"
                    onChange={handleOnchange}
                    error={error.weight}
                    value={data?.weight}
                    name="weight"
                  />
                </div>
                <div className="product-list-form-row">
                  <WebInput
                    type="text"
                    placeholder=""
                    label="WARRANTY"
                    id="warranty"
                    onChange={handleOnchange}
                    error={error.warranty}
                    value={data?.warranty}
                    name="warranty"
                  />
                  <WebInput
                    type="text"
                    placeholder=""
                    label="HSN"
                    id="hsn"
                    onChange={handleOnchange}
                    error={error.hsn}
                    value={data?.hsn}
                    name="hsn"
                  />
                </div>
              </div>
            </div> */}

            {/* Images */}
            <div id="images" className="product-list-form-section">
              <div className="product-list-section-header">
                <h2>Images</h2>
                <button type="button" className="product-list-collapse-btn" onClick={() => toggleSection("images")}>
                  {collapsed["images"] ? "Expand" : "Collapse"}
                </button>
              </div>
              <div className={`product-list-section-body ${collapsed["images"] ? "product-list-collapsed" : ""}`}>
                <div className="flex gap-2 flex-wrap">
                  {data?.imgUrl?.map((img, index) => (
                    <div key={index} className="relative">
                      <img 
                        src={normalizeUrl(img)} 
                        alt="img" 
                        className="w-24 product-list-image-cross" 
                        onError={handleImgError}
                        referrerPolicy="no-referrer"
                      />
                      <button
                        className="product-list-remove-icon"
                        onClick={() => handleRemoveImage(index)}
                      >
                        <RxCross2 />
                      </button>
                    </div>
                  ))}

                  {selectedImage && (
                    <img
                      src={URL.createObjectURL(selectedImage)}
                      alt="selected"
                      className="w-24"
                    />
                  )}

                  <label htmlFor="file-input" className="product-list-file-input-label">
                    +
                  </label>

                  <input
                    type="file"
                    id="file-input"
                    className="product-list-file-input"
                    onChange={handleImage}
                  />

                  <WebButton
                    onClick={() => handleImageUpload(data._id)}
                    text="Upload"
                    className="bg-blue-500 text-white p-2"
                  />
                </div>
              </div>
            </div>

            {/* Variations Section */}
            {data?.variations && data.variations.length > 0 && (
              <section id="variations" className="product-list-form-section">
                <div className="product-list-variants-header">
                  <h3>Variations</h3>

                  <div className="product-list-variant-actions" style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <strong style={{ fontSize: 12, fontWeight: 600 }}>Update Markup</strong>

                      {bulkMarkupMode === "percentage" ? (
                        <input
                          type="number"
                          value={bulkPercentage}
                          onChange={(e) => setBulkPercentage(e.target.value)}
                          placeholder="Percentage %"
                          style={{width: 140, height: 22, padding: "4px 8px", fontSize: 12, borderRadius: 5, border: "1px solid #ccc", }}
                        />
                      ) : (
                        <input
                          type="number"
                          value={bulkTargetPrice}
                          onChange={(e) => setBulkTargetPrice(e.target.value)}
                          placeholder="Target Price ₹"
                          style={{ width: 140, height: 22, padding: "4px 8px", fontSize: 12, borderRadius: 5, border: "1px solid #ccc", }}
                        />
                      )}

                      <button
                        type="button"
                        disabled={isBulkApplyDisabled}
                        onClick={() => {
                          if (bulkMarkupMode === "percentage") {
                            applyBulkPercentageToAllVariants();
                          } else {
                            applyBulkTargetPriceToAllVariants();
                          }
                        }}
                        style={{ height: 22, fontSize: 12, padding: "0 10px",opacity: isBulkApplyDisabled ? 0.5 : 1, cursor: isBulkApplyDisabled ? "not-allowed" : "pointer", }}
                      >
                        Apply to all
                      </button>
                    </div>

                    {/* Radios */}
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                      <label style={{display: "flex", alignItems: "center", gap: 4, fontSize: 12, cursor: "pointer", }} >
                        <input
                          type="radio"
                          name="bulkMarkupMode"
                          checked={bulkMarkupMode === "percentage"}
                          onChange={() => setBulkMarkupMode("percentage")}
                          style={{ transform: "scale(0.9)" }} 
                        />
                        Via Percentage
                      </label>

                      <label style={{display: "flex", alignItems: "center", gap: 4, fontSize: 12, cursor: "pointer", }} >
                        <input
                          type="radio"
                          name="bulkMarkupMode"
                          checked={bulkMarkupMode === "targetPrice"}
                          onChange={() => setBulkMarkupMode("targetPrice")}
                          style={{ transform: "scale(0.9)" }}
                        />
                        Via Target Price
                      </label>
                    </div>
                    <div ref={variantBulkMenuRef} style={{ position: "relative", display: "flex", alignItems: "center" }}>
                      <button
                        type="button"
                        onClick={() => setVariantBulkMenuOpen((v) => !v)}
                        title="Bulk select options"
                        style={{height: 22, width: 32, borderRadius: 8, border: "1px solid #e5e7eb", background: "#ffffff", display: "inline-flex", alignItems: "center", justifyContent: "center", cursor: "pointer", boxShadow: "0 1px 2px rgba(0,0,0,0.04)", }}
                      >
                        {/* icon: checklist */}
                        <svg width="16" height="16" viewBox="0 0 20 20" fill="none">
                          <path d="M9 6h12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                          <path d="M9 12h12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                          <path d="M9 18h12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                          <path d="M3.5 6l1.5 1.5L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M3.5 12l1.5 1.5L7.5 11" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </button>

                      {variantBulkMenuOpen && (
                        <div onMouseDown={(e) => e.stopPropagation()} //  prevents menu close
                          style={{position: "absolute", top: 34, right: 0, minWidth: 220, background: "#fff", border: "1px solid #e5e7eb", borderRadius: 10, boxShadow: "0 10px 25px rgba(0,0,0,0.12)", padding: 6, zIndex: 50, }}
                        >
                          <button
                            type="button"
                            onClick={() => {
                              setAllVariants(true);
                            }}
                            style={{width: "100%", display: "flex", alignItems: "flex-start", gap: 10, padding: "10px 10px", borderRadius: 8, border: "none", background: "transparent", cursor: "pointer", }}
                            onMouseEnter={(e) => (e.currentTarget.style.background = "#f3f4f6")}
                            onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                          >
                            <input
                              type="checkbox"
                              checked={allVariantsChecked}
                              readOnly
                              onMouseDown={(e) => e.stopPropagation()}
                              style={{ marginTop: 3 }}
                            />
                            <div style={{ textAlign: "left" }}>
                              <div style={{ fontSize: 12, fontWeight: 700, color: "#111827" }}> Keep all variants</div>
                              <div style={{ fontSize: 11, color: "#6b7280", lineHeight: 1.25 }}>Mark all as <b>active</b> (no deletion)</div>
                            </div>
                          </button>

                          <button
                            type="button"
                            onClick={() => {
                              setAllVariants(false);
                            }}
                            style={{
                              width: "100%",
                              display: "flex",
                              alignItems: "flex-start",
                              gap: 10,
                              padding: "10px 10px",
                              borderRadius: 8,
                              border: "none",
                              background: "transparent",
                              cursor: "pointer",
                            }}
                            onMouseEnter={(e) => (e.currentTarget.style.background = "#fef2f2")}
                            onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                          >
                            <input
                              type="checkbox"
                              checked={allVariantsUnchecked}
                              readOnly
                              onMouseDown={(e) => e.stopPropagation()}
                              style={{ marginTop: 3 }}
                            />
                            <div style={{ textAlign: "left" }}>
                              <div style={{ fontSize: 12, fontWeight: 700, color: "#991b1b" }}>
                                Delete all variants
                              </div>
                              <div style={{ fontSize: 11, color: "#6b7280", lineHeight: 1.25 }}>
                                Mark all as <b>delete</b> (removed from DB on save)
                              </div>
                            </div>
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Pricing Mode Tabs - Separate Row */}
                <div style={{ display: "flex", gap: 8, marginTop: 12, marginBottom: 12, borderBottom: "1px solid #e5e7eb", paddingBottom: 8 }}>
                  <button
                    type="button"
                    onClick={() => handlePricingModeChange("dropshipping")}
                    style={{
                      padding: "4px 12px",
                      height: "22px",
                      border: "none",
                      background: pricingMode === "dropshipping" ? "#2563eb" : "transparent",
                      color: pricingMode === "dropshipping" ? "#fff" : "#6b7280",
                      cursor: "pointer",
                      borderBottom: pricingMode === "dropshipping" ? "2px solid #2563eb" : "2px solid transparent",
                      fontWeight: pricingMode === "dropshipping" ? 600 : 400,
                      fontSize: 12,
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    Dropshipping
                  </button>
                  <button
                    type="button"
                    onClick={() => handlePricingModeChange("wholesale")}
                    style={{
                      padding: "4px 12px",
                      height: "22px",
                      border: "none",
                      background: pricingMode === "wholesale" ? "#2563eb" : "transparent",
                      color: pricingMode === "wholesale" ? "#fff" : "#6b7280",
                      cursor: "pointer",
                      borderBottom: pricingMode === "wholesale" ? "2px solid #2563eb" : "2px solid transparent",
                      fontWeight: pricingMode === "wholesale" ? 600 : 400,
                      fontSize: 12,
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    Wholesale
                  </button>
                </div>

                {data.variations.map((variation, index) => {
                  const key = variation?.sku || variation?.skuId || variation?.specId || `${variation?.color || ''}-${variation?.size || ''}` || String(index);
                  
                  return (
                    <div key={index} className="product-list-variation-card">
                      <div className="product-list-variation-header">
                        <div className="product-list-variation-left">
                          {variation.skuAttributes && variation.skuAttributes.length > 0 && variation.skuAttributes[0].skuImageUrl ? (
                            <img 
                              src={normalizeUrl(variation.skuAttributes[0].skuImageUrl)} 
                              alt="Variation Image" 
                              className="product-list-variation-image"
                              referrerPolicy="no-referrer"
                              onError={handleImgError}
                            />
                          ) : null}

                          <h3>
                            {variation.skuAttributes && variation.skuAttributes.length > 0
                              ? variation.skuAttributes[0].valueTrans || variation.skuAttributes[0].value
                              : "Variations"}
                          </h3>
                        </div>

                        <button
                          type="button"
                          className="product-list-variant-update-price-btn"
                          onClick={() => openVariantPriceModal(variation, index)}
                        >
                          Update Price with Algo
                        </button>
                        
                        <label className="product-list-variant-select">
                          Uncheck to delete variant from DB 
                          <input
                            type="checkbox"
                            checked={!!variantSelection[key]}
                            onChange={() => toggleVariantSelection(variation)}
                          />
                        </label>
                      </div>

                      <div className="product-list-form-row product-list-variation-form-row">
                        <div className="product-list-variation-form-input">
                          <label>sku Id</label>
                          <input
                            readOnly
                            type="number"
                            value={variation.skuId || ""}
                            onChange={(e) => handleVariationChange(index, "skuId", e.target.value)}
                          />
                        </div>
                        <div className="product-list-variation-form-input">
                          <label>Amount On Sale</label>
                          <input
                            type="number"
                            value={variation.amountOnSale || ""}
                            onChange={(e) => handleVariationChange(index, "amountOnSale", e.target.value)}
                          />
                        </div>
                        <div className="product-list-variation-form-input">
                          <label>Consign Price</label>
                          <input
                            readOnly
                            type="text"
                            value={variation.cp || ""}
                            onChange={(e) => handleVariationChange(index, "cp", e.target.value)}
                          />
                        </div>
                        <div className="product-list-variation-form-input">
                          <label>Weight (kg)</label>
                          <input
                            readOnly
                            type="number"
                            value={variation.weight ?? 0}
                            onChange={(e) => handleVariationChange(index, "weight", e.target.value === "" ? 0 : +e.target.value)}
                          />
                        </div>
                        <div className="product-list-variation-form-input">
                          <label>Length (cm)</label>
                          <input
                            readOnly
                            type="number"
                            value={variation.length ?? 0}
                            onChange={(e) => handleVariationChange(index, "length", e.target.value === "" ? 0 : +e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="product-list-form-row product-list-variation-form-row">
                        <div className="product-list-variation-form-input">
                          <label>Height (cm)</label>
                          <input
                            readOnly
                            type="number"
                            value={variation.height ?? 0}
                            onChange={(e) => handleVariationChange(index, "height", e.target.value === "" ? 0 : +e.target.value)}
                          />
                        </div>
                        <div className="product-list-variation-form-input">
                          <label>Width (cm)</label>
                          <input
                            readOnly
                            type="number"
                            value={variation.width ?? 0}
                            onChange={(e) => handleVariationChange(index, "width", e.target.value === "" ? 0 : +e.target.value)}
                          />
                        </div>

                        <div className="product-list-variation-form-input">
                          <label>Actual Price</label>
                          <input
                            readOnly
                            type="number"
                            value={variation.ap ?? variation.actualPrice ?? 0}
                            onChange={(e) => handleVariationChange(index, "ap", e.target.value)}
                          />
                        </div>
                        {pricingMode === "dropshipping" ? (
                          <>
                            <div className="product-list-variation-form-input">
                              <label>Final Price </label>
                              <input
                                readOnly
                                type="number"
                                value={variation.finalPrice || ""}
                                onChange={(e) => handleVariationChange(index, "finalPrice", e.target.value)}
                              />
                            </div>
                            <div className="product-list-variation-form-input">
                              <label>Final Price MRP</label>
                              <input
                                readOnly
                                type="number"
                                value={Number(variation.finalPriceMRP || 0).toFixed(2)}
                                onChange={(e) => handleVariationChange(index, "finalPriceMRP", e.target.value)}
                              />
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="product-list-variation-form-input">
                              <label>Wholesale Final Price </label>
                              <input
                                readOnly
                                type="number"
                                value={variation.wholesaleFinalPrice || ""}
                                onChange={(e) => handleVariationChange(index, "wholesaleFinalPrice", e.target.value)}
                              />
                            </div>
                          </>
                        )}
                      </div>
                      {/* Fenxiao Price Info */}
                      {variation.fenxiaoPriceInfo && (
                        <div className="product-list-fenxiao-price-info">
                          <div className="product-list-fenxiao-headings">
                            <h4>Fenxiao Price Info : </h4>
                            <h4>Markup Settings :</h4>
                          </div>
                          <div className="product-list-variant-price-row5">
                            {/* Fenxiao */}
                            <div className="product-list-variation-form-input">
                              <label>Offer Price</label>
                              <input
                                readOnly
                                type="text"
                                // Hidden for now because offer price is not correct from API some other calculation happens when fetch data that is why offer price is not correct but in db it is correct.
                                // value={variation.fenxiaoPriceInfo.offerPrice || ""}
                                // onChange={(e) => handleVariationChange(index, "fenxiaoPriceInfo.offerPrice", e.target.value)}
                              />
                            </div>
                  
                            <div className="product-list-variation-form-input">
                              <label>One Piece Price</label>
                              <input
                                readOnly
                                type="text"
                                value={variation.fenxiaoPriceInfo.onePiecePrice || ""}
                                onChange={(e) => handleVariationChange(index, "fenxiaoPriceInfo.onePiecePrice", e.target.value)}
                              />
                            </div>

                            {/* RIGHT: Markup */}
                            {pricingMode === "dropshipping" ? (
                              <>
                                <div className="product-list-variation-form-input">
                                  <label>Set Percentage (%)</label>
                                  <input
                                    type="number"
                                    value={variation.percentage ?? ""}
                                    onChange={(e) => handleVariationChange(index, "percentage", e.target.value)}
                                  />
                                </div>

                                <div className="product-list-variation-form-input">
                                  <label>Set Target Price</label>
                                  <input
                                    type="number"
                                    value={variation.targetPrice ?? ""}
                                    onChange={(e) => handleVariationChange(index, "targetPrice", e.target.value)}
                                  />
                                </div>
                              </>
                            ) : (
                              <>
                                <div className="product-list-variation-form-input">
                                  <label>Wholesale Percentage (%)</label>
                                  <input
                                    type="number"
                                    value={variation.wholesalePercentage ?? ""}
                                    onChange={(e) => handleVariationChange(index, "wholesalePercentage", e.target.value)}
                                  />
                                </div>

                                <div className="product-list-variation-form-input">
                                  <label>Wholesale Target Price</label>
                                  <input
                                    type="number"
                                    value={variation.wholesaleTargetPrice ?? ""}
                                    onChange={(e) => handleVariationChange(index, "wholesaleTargetPrice", e.target.value)}
                                  />
                                </div>
                              </>
                            )}

                            {/* Update button */}
                            <div className="product-list-variation-form-input">
                              <label style={{ visibility: "hidden" }}>Update</label>
                              <button
                                type="button"
                                className="product-list-variant-row-update-btn"
                                onClick={() => handleUpdateVariant(index)}
                                disabled={variantUpdating || loading}
                              >
                                {variantUpdating ? "Updating..." : "Update Variant"}
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </section>
            )}

            {/* Price Ranges Section */}
            <section id="price-ranges" className="form-section">
              <div className="product-list-section-header">
                <h2>Price Ranges</h2>
                <button
                  type="button"
                  className="product-list-collapse-btn"
                  onClick={() => toggleSection("price-ranges")}
                >
                  {collapsed["price-ranges"] ? "Expand" : "Collapse"}
                </button>
              </div>
              <div className={`product-list-section-body ${ collapsed["price-ranges"] ? "product-list-collapsed" : ""}`}>
                <p style={{ fontSize: "13px", color: "#2563eb", marginBottom: "16px", fontWeight: 500, backgroundColor: "#eff6ff", padding: "10px 12px", borderRadius: "6px", border: "1px solid #bfdbfe" }}>
                  When variant details are not available, update the Price Range (RMB) to auto-calculate Final Price.
                  <br />
                  <span style={{ fontSize: "12px", color: "#64748b" }}>
                    Note: Price Range edits are not saved in Price Log History.
                  </span>
                </p>

                {data.priceRanges && data.priceRanges.length > 0 ? (
                  <div className="price-ranges-list">
                    {data.priceRanges.map((priceRange, index) => (
                      <div key={priceRange.id || index} className="price-range-item" style={{
                        border: "1px solid #e5e7eb",
                        borderRadius: "8px",
                        padding: "16px",
                        marginBottom: "12px",
                        backgroundColor: "#f9fafb",
                      }}>
                        <h4 style={{ fontSize: "14px", fontWeight: 600, margin: "0 0 12px 0" }}>Price Range #{index + 1}</h4>

                        <div className="form-row product-list-variation-form-row">
                          <div className="variation-form-input">
                            <label>Start Quantity</label>
                            <input
                              type="number"
                              value={priceRange.startQuantity || ""}
                              onChange={(e) => handlePriceRangesChange("startQuantity", e.target.value, index)}
                              placeholder="e.g., 1, 2, 10"
                              readOnly
                            />
                          </div>
                          <div className="variation-form-input">
                            <label>Price (RMB)</label>
                            <input
                              type="number"
                              step="0.01"
                              value={priceRange.price || ""}
                              onChange={(e) => handlePriceRangesChange("price", e.target.value, index)}
                              placeholder="Base price"
                            />
                          </div>
                          <div className="variation-form-input">
                            <label>Final Price (₹)</label>
                            <input
                              type="number"
                              step="0.01"
                              value={priceRange.finalPrice || ""}
                              onChange={(e) => handlePriceRangesChange("finalPrice", e.target.value, index)}
                              placeholder="Final calculated price in INR"
                              readOnly
                            />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div style={{
                    padding: "24px",
                    textAlign: "center",
                    color: "#6b7280",
                    backgroundColor: "#f9fafb",
                    borderRadius: "8px",
                    border: "1px dashed #d1d5db"
                  }}>
                    <p style={{ margin: 0, fontSize: "14px" }}>No price ranges available.</p>
                  </div>
                )}
              </div>
            </section>

            {priceRangeCalcOpen && (
              <div
                style={{
                  position: "fixed",
                  right: 16,
                  top: 210,
                  width: 390,
                  maxHeight: "calc(100vh - 130px)",
                  background: "#fff",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.18)",
                  borderRadius: 12,
                  zIndex: 9999,
                  overflow: "hidden",
                  pointerEvents: "auto",
                }}
              >
                <div style={{ padding: 16, overflowY: "auto", maxHeight: "calc(100vh - 130px)" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
                    <div>
                      <div style={{ fontWeight: 700, fontSize: 14 }}>Price Breakdown</div>
                      <div style={{ fontSize: 12, color: "#64748b" }}>
                        Row #{(priceRangeCalcMeta?.index ?? 0) + 1} • AP (RMB): {priceRangeCalcMeta?.ap}
                      </div>
                    </div>

                    <button
                      type="button"
                      onClick={() => setPriceRangeCalcOpen(false)}
                      style={{
                        border: "1px solid #e5e7eb",
                        borderRadius: 8,
                        padding: "2px 8px",
                        cursor: "pointer",
                        background: "#fff",
                      }}
                      aria-label="Close"
                    >
                      ✕
                    </button>
                  </div>

                  {priceRangeCalcLoading && (
                    <div style={{ fontSize: 13, color: "#475569", padding: "10px 12px", background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 8 }}>
                      Calculating price...
                    </div>
                  )}

                  {priceRangeCalcError && (
                    <div style={{ fontSize: 13, color: "#b91c1c", padding: "10px 12px", background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 8 }}>
                      {priceRangeCalcError}
                    </div>
                  )}

                  {priceRangeCalcResult?.breakdown && !priceRangeCalcLoading && (
                    <div style={{ marginTop: 12 }}>
                      <div style={{ fontSize: 12, color: "#64748b", marginBottom: 6 }}>
                        Algorithm: <b>{priceRangeCalcResult.algorithm || "---"}</b>
                      </div>

                      <div style={{ padding: 12, border: "1px solid #e5e7eb", borderRadius: 10, background: "#f9fafb" }}>
                        <div style={{ fontWeight: 800, fontSize: 16, color: "#16a34a", marginBottom: 10 }}>
                          FBP (Final Buyer Price): ₹{Math.round(Number(priceRangeCalcResult.breakdown.FBP || 0))}
                        </div>

                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, fontSize: 12, color: "#0f172a" }}>
                          <div>AP_RMB: {priceRangeCalcResult.breakdown.AP_RMB}</div>
                          <div>AP_INR: ₹{Math.round(Number(priceRangeCalcResult.breakdown.AP_INR || 0))}</div>
                          <div>MP: ₹{Math.round(Number(priceRangeCalcResult.breakdown.MP || 0))}</div>
                          <div>CP: ₹{Math.round(Number(priceRangeCalcResult.breakdown.CP || 0))}</div>
                          <div>LS: ₹{Math.round(Number(priceRangeCalcResult.breakdown.LS || 0))}</div>
                          <div>CD: ₹{Math.round(Number(priceRangeCalcResult.breakdown.CD || 0))}</div>
                          <div>IF: ₹{Math.round(Number(priceRangeCalcResult.breakdown.IF || 0))}</div>
                          <div>LMD: ₹{Math.round(Number(priceRangeCalcResult.breakdown.LMD || 0))}</div>
                          <div>LC: ₹{Math.round(Number(priceRangeCalcResult.breakdown.LC || 0))}</div>
                          <div>PF: ₹{Math.round(Number(priceRangeCalcResult.breakdown.PF || 0))}</div>
                          <div>GST_PR: ₹{Math.round(Number(priceRangeCalcResult.breakdown.GST_PR || 0))}</div>
                          <div>GST_FR: ₹{Math.round(Number(priceRangeCalcResult.breakdown.GST_FR || 0))}</div>
                          <div>GST_PF: ₹{Math.round(Number(priceRangeCalcResult.breakdown.GST_PF || 0))}</div>
                          <div>Chargeable Wt: {priceRangeCalcResult.breakdown.chargeableWeight || "-"} kg</div>
                        </div>

                        <div style={{ marginTop: 12, paddingTop: 10, borderTop: "1px dashed #e5e7eb", fontSize: 12, color: "#334155" }}>
                          <div><b>Weight Used</b></div>
                          <div>VW: {priceRangeCalcResult.breakdown.volumetricWeightKg} kg</div>
                          <div>DW: {priceRangeCalcResult.breakdown.deadWeightKg} kg</div>
                        </div>
                      </div>

                      <div style={{ marginTop: 10, fontSize: 12, color: "#64748b" }}>
                        Note: This breakdown is preview only. Save it by clicking <b>Update Product</b>.
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Product Sale Info Section */}
            {data?.productSaleInfo && (
              <section className="product-list-form-section">
                <h2>Product Sale Info</h2>
                <div className="product-list-form-row product-list-variation-form-row">
                  <div className="product-list-variation-form-input">
                    <label>Amount On Sale</label>
                    <input
                      type="number"
                      value={data.productSaleInfo?.amountOnSale || ""}
                      onChange={(e) => handleProductSaleInfoChange("amountOnSale", e.target.value)}
                    />
                  </div>
                </div>

                {/* Price Range List */}
                <h3>Price Range</h3>
                {data.productSaleInfo?.priceRangeList?.map((priceRange, index) => (
                  <div key={index} className="product-list-price-range-item">
                    <div className="product-list-form-row product-list-variation-form-row">
                      <div className="product-list-variation-form-input">
                        <label>Start Quantity</label>
                        <input
                          readOnly
                          type="number"
                          value={priceRange.startQuantity || ""}
                          onChange={(e) => handleProductSaleInfoChange(`priceRangeList.startQuantity`, e.target.value, index)}
                        />
                      </div>
                      <div className="product-list-variation-form-input">
                        <label>Price</label>
                        <input
                          readOnly
                          type="number"
                          value={priceRange.price || ""}
                          onChange={(e) => handleProductSaleInfoChange(`priceRangeList.price`, e.target.value, index)}
                        />
                      </div>
                      <div className="product-list-variation-form-input">
                        <label>Promotion Price</label>
                        <input
                          readOnly
                          type="text"
                          value={priceRange.promotionPrice || ""}
                          onChange={(e) => handleProductSaleInfoChange(`priceRangeList.promotionPrice`, e.target.value, index)}
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </section>
            )}

            {/* Product Details (mirroring draft layout, but using product-list classes) */}
            <div id="product-details" className="product-list-form-section">
              <div className="product-list-section-header">
                <h2>Product Details</h2>
                <button
                  type="button"
                  className="product-list-collapse-btn"
                  onClick={() => toggleSection("product-details")}
                >
                  {collapsed["product-details"] ? "Expand" : "Collapse"}
                </button>
              </div>
              <div
                className={`product-list-section-body ${
                  collapsed["product-details"] ? "product-list-collapsed" : ""
                }`}
              >
                <div className="product-list-form-row">
                  <WebInput
                    label="Feed Product Type"
                    name="feed_product_type"
                    value={data.feed_product_type}
                    onChange={handleOnchange}
                    parentClassName="product-list-form-input"
                  />
                  <WebInput
                    label="Style Name"
                    name="style_name"
                    value={data.style_name}
                    onChange={handleOnchange}
                    parentClassName="product-list-form-input"
                  />
                  <div className="product-list-form-input">
                    <label>Target Gender</label>
                    <input
                      type="text"
                      name="target_gender"
                      value={data.target_gender || ""}
                      onChange={handleOnchange}
                    />
                  </div>
                  <WebInput
                    label="Age Range Description"
                    name="age_range_description"
                    value={data.age_range_description}
                    onChange={handleOnchange}
                    parentClassName="product-list-form-input"
                  />
                </div>

                <div className="product-list-form-row">
                  <WebInput
                    label="Material Type"
                    name="material_type"
                    value={data.material_type}
                    onChange={handleOnchange}
                    parentClassName="product-list-form-input"
                  />
                  <WebInput
                    label="Fabric Type"
                    name="fabric_type"
                    value={data.fabric_type}
                    onChange={handleOnchange}
                    parentClassName="product-list-form-input"
                  />
                  <WebInput
                    label="Pattern Type"
                    name="pattern_type"
                    value={data.pattern_type}
                    onChange={handleOnchange}
                    parentClassName="product-list-form-input"
                  />
                  <WebInput
                    label="Color Map"
                    name="color_map"
                    value={data.color_map}
                    onChange={handleOnchange}
                    parentClassName="product-list-form-input"
                  />
                </div>

                <div className="product-list-form-row">
                  <WebInput
                    label="Size Map"
                    name="size_map"
                    value={data.size_map}
                    onChange={handleOnchange}
                    parentClassName="product-list-form-input"
                  />
                  <WebInput
                    label="Fit Type"
                    name="fit_type"
                    value={data.fit_type}
                    onChange={handleOnchange}
                    parentClassName="product-list-form-input"
                  />
                  <WebInput
                    label="Rise Style"
                    name="rise_style"
                    value={data.rise_style}
                    onChange={handleOnchange}
                    parentClassName="product-list-form-input"
                  />
                  <WebInput
                    label="Lifestyle"
                    name="lifestyle"
                    value={data.lifestyle}
                    onChange={handleOnchange}
                    parentClassName="product-list-form-input"
                  />
                </div>

                <div className="product-list-form-row">
                  <WebInput
                    label="Number of Pockets"
                    name="number_of_pockets"
                    type="number"
                    value={data.number_of_pockets}
                    onChange={handleOnchange}
                    parentClassName="product-list-form-input"
                  />
                  <WebInput
                    label="Unit Count"
                    name="unit_count"
                    type="number"
                    value={data.unit_count}
                    onChange={handleOnchange}
                    parentClassName="product-list-form-input"
                  />
                  <WebInput
                    label="Unit Count Type"
                    name="unit_count_type"
                    value={data.unit_count_type}
                    onChange={handleOnchange}
                    parentClassName="product-list-form-input"
                  />
                  <WebInput
                    label="Duration"
                    name="duration"
                    value={data.duration}
                    onChange={handleOnchange}
                    parentClassName="product-list-form-input"
                  />
                </div>

                <div className="product-list-form-row">
                  <WebInput
                    label="Duration Unit of Measure"
                    name="duration_unit_of_measure"
                    value={data.duration_unit_of_measure}
                    onChange={handleOnchange}
                    parentClassName="product-list-form-input"
                  />
                  <WebInput
                    label="Country of Origin"
                    name="country_of_origin"
                    value={data.country_of_origin}
                    onChange={handleOnchange}
                    parentClassName="product-list-form-input"
                  />
                  <WebInput
                    label="Department Name"
                    name="department_name"
                    value={data.department_name}
                    onChange={handleOnchange}
                    parentClassName="product-list-form-input"
                  />
                  <WebInput
                    label="Item Type Name"
                    name="item_type_name"
                    value={data.item_type_name}
                    onChange={handleOnchange}
                    parentClassName="product-list-form-input"
                  />
                </div>

                <div className="product-list-form-row">
                  <WebInput
                    label="Item Length Description"
                    name="item_length_description"
                    value={data.item_length_description}
                    onChange={handleOnchange}
                    parentClassName="product-list-form-input"
                  />
                  <WebInput
                    label="Pocket Description"
                    name="pocket_description"
                    value={data.pocket_description}
                    onChange={handleOnchange}
                    parentClassName="product-list-form-input"
                  />
                  <WebInput
                    label="Care Instructions"
                    name="care_instructions"
                    value={data.care_instructions}
                    onChange={handleOnchange}
                    parentClassName="product-list-form-input"
                  />
                  <WebInput
                    label="Number of Items"
                    name="number_of_items"
                    type="number"
                    value={data.number_of_items}
                    onChange={handleOnchange}
                    parentClassName="product-list-form-input"
                  />
                </div>

                <div className="product-list-form-row">
                  <WebInput
                    label="Packer Contact Information"
                    name="packer_contact_information"
                    value={data.packer_contact_information}
                    onChange={handleOnchange}
                    parentClassName="product-list-form-input"
                  />
                  <WebInput
                    label="Manufacturer Contact Information"
                    name="manufacturer_contact_information"
                    value={data.manufacturer_contact_information}
                    onChange={handleOnchange}
                    parentClassName="product-list-form-input"
                  />
                </div>
              </div>
            </div>

            {/* SEO & Keywords */}
            <div id="seo-keywords" className="product-list-form-section">
              <div className="product-list-section-header">
                <h2>SEO & Keywords</h2>
                <button
                  type="button"
                  className="product-list-collapse-btn"
                  onClick={() => toggleSection("seo-keywords")}
                >
                  {collapsed["seo-keywords"] ? "Expand" : "Collapse"}
                </button>
              </div>
              <div
                className={`product-list-section-body ${
                  collapsed["seo-keywords"] ? "product-list-collapsed" : ""
                }`}
              >
                <div className="product-list-form-row">
                  <WebInput
                    label="Generic Keywords"
                    name="generic_keywords"
                    value={data.generic_keywords}
                    onChange={handleOnchange}
                    parentClassName="product-list-form-input product-list-form-span-2"
                  />
                  <WebInput
                    label="Search Terms (comma separated)"
                    name="search_terms"
                    value={data.search_terms}
                    onChange={handleOnchange}
                    parentClassName="product-list-form-input"
                  />
                  <WebInput
                    label="Target Audience (comma separated)"
                    name="target_audience"
                    value={data.target_audience}
                    onChange={handleOnchange}
                    parentClassName="product-list-form-input"
                  />
                </div>

                <div className="product-list-form-row">
                  <WebInput
                    label="Bullet Point 1"
                    name="bullet_point1"
                    value={data.bullet_point1}
                    onChange={handleOnchange}
                    parentClassName="product-list-form-input"
                  />
                  <WebInput
                    label="Bullet Point 2"
                    name="bullet_point2"
                    value={data.bullet_point2}
                    onChange={handleOnchange}
                    parentClassName="product-list-form-input"
                  />
                  <WebInput
                    label="Bullet Point 3"
                    name="bullet_point3"
                    value={data.bullet_point3}
                    onChange={handleOnchange}
                    parentClassName="product-list-form-input"
                  />
                  <WebInput
                    label="Bullet Point 4"
                    name="bullet_point4"
                    value={data.bullet_point4}
                    onChange={handleOnchange}
                    parentClassName="product-list-form-input"
                  />
                </div>

                <div className="product-list-form-row">
                  <WebInput
                    label="Bullet Point 5"
                    name="bullet_point5"
                    value={data.bullet_point5}
                    onChange={handleOnchange}
                    parentClassName="product-list-form-input"
                  />
                </div>
              </div>
            </div>

            {/* Draft Specific Information */}
            <div id="draft-info" className="product-list-form-section">
              <div className="product-list-section-header">
                <h2>Draft Specific Information</h2>
                <button
                  type="button"
                  className="product-list-collapse-btn"
                  onClick={() => toggleSection("draft-info")}
                >
                  {collapsed["draft-info"] ? "Expand" : "Collapse"}
                </button>
              </div>
              <div
                className={`product-list-section-body ${
                  collapsed["draft-info"] ? "product-list-collapsed" : ""
                }`}
              >
                <div className="product-list-form-row">
                  <WebInput
                    label="Offer ID"
                    name="offerId"
                    value={data.offerId}
                    onChange={handleOnchange}
                    parentClassName="product-list-form-input"
                    readonly={true}
                  />
                  <WebInput
                    label="Source"
                    name="source"
                    value={data.source}
                    onChange={handleOnchange}
                    parentClassName="product-list-form-input"
                  />
                  <WebInput
                    label="Location"
                    name="location"
                    value={data.location}
                    onChange={handleOnchange}
                    parentClassName="product-list-form-input"
                  />
                  <WebInput
                    label="Processing Status"
                    name="processingStatus"
                    value={data.processingStatus}
                    onChange={handleOnchange}
                    parentClassName="product-list-form-input"
                  />
                </div>

                <div className="product-list-form-row">
                  <WebInput
                    label="Is Display"
                    name="is_display"
                    value={data.is_display}
                    onChange={handleOnchange}
                    parentClassName="product-list-form-input"
                  />
                  <label className="product-list-variation-form-input">
                    <span>Is Deleted</span>
                    <input
                      type="checkbox"
                      name="is_delete"
                      checked={!!data.is_delete}
                      onChange={(e) =>
                        setData((prev) => ({
                          ...prev,
                          is_delete: e.target.checked,
                        }))
                      }
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      {remarkModalOpen ? (
        <div className="remark-modal-backdrop" onMouseDown={closeRemarkModal}>
          <div className="remark-modal" onMouseDown={(e) => e.stopPropagation()}>
            <div className="remark-modal-head">
              <div>
                <h3 className="remark-modal-title">Add Remark</h3>
                <p className="remark-modal-sub">Remark is mandatory</p>
              </div>
              <button type="button"
               className="remark-modal-close"
                onClick={closeRemarkModal}
                disabled={loading || variantUpdating}
                >
                ×
              </button>
            </div>

            <textarea
              className="remark-modal-input"
              placeholder="Enter remark..."
              value={remarkText}
              onChange={(e) => setRemarkText(e.target.value)}
              rows={4}
              autoFocus
            />

            <div className="remark-modal-actions">
              <button type="button"
                className="remark-modal-btn ghost"
                onClick={closeRemarkModal}
                disabled={loading || variantUpdating}
                >
                Cancel
              </button>
              <button type="button"
                className="remark-modal-btn" 
                onClick={submitRemark}
                disabled={loading || variantUpdating}
                >
                {(loading || variantUpdating) ? "Saving..." : "Save"}
              </button>
            </div>
           </div>
         </div>
     ) : null}

      <VariantPriceModal
        open={variantPriceModalOpen}
        onClose={closeVariantPriceModal}
        variation={activeVariant}
        onApplyPrice={applyVariantPrice}
        onApplyDimensions={applyVariantDimensions}
        localShipping={activeVariant?.ls ?? activeVariant?.localShipping ?? data?.local_shipping ?? ""}
        defaultCategoryId={data?.categoryId}
        pricingMode={pricingMode}
        allVariants={data?.variations || []}
        onApplyMultipleVariants={applyMultipleVariants}
      />
    </div>
  );
}